import { Injectable, signal } from '@angular/core';
import { AppInterface } from '../../interfaces/app.interface';

@Injectable({
  providedIn: 'root',
})
export class AppDetailsService {
  private _currentAppDetails = signal<AppInterface>({} as AppInterface);
  public currentAppDetails = this._currentAppDetails.asReadonly();

  // Event: App added/removed (for UI-Sync in detail page)
  private _appAddedOrRemoved = signal<{ appId: number; isAdded: boolean } | null>(null);
  public appAddedOrRemoved = this._appAddedOrRemoved.asReadonly();

  setCurrentAppDetails(appDetails: AppInterface): void {
    this._currentAppDetails.set(appDetails);
  }

  notifyAppAddedOrRemoved(appId: number, isAdded: boolean): void {
    this._appAddedOrRemoved.set({ appId, isAdded });
  }
}
